import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadLaboratoryContractByLaboratoryId: ILaboratoryContractLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_LABORATORYCONTRACT_LOAD_BY_LABORATORY_ID,
            laboratoryId
        }
    },
    LoadLaboratoryContractById: ILaboratoryContractLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_LABORATORYCONTRACT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ILaboratoryContractLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ILaboratoryContractLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveLaboratoryContract: ILaboratoryContractSaveActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYCONTRACT_SAVE,
            formData
        }
    },
    SaveSuccess: ILaboratoryContractSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ILaboratoryContractSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateLaboratoryContract: ILaboratoryContractValidateActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYCONTRACT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ILaboratoryContractValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ILaboratoryContractValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateLaboratoryContract: ILaboratoryContractCreateActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYCONTRACT_CREATE,
            laboratoryId
        }
    },
    CreateSuccess: ILaboratoryContractCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_LABORATORYCONTRACT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ILaboratoryContractCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncLaboratoryContract: ILaboratoryContractSyncActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYCONTRACT_SYNC,
            laboratoryId
        }
    },
    SyncSuccess: ILaboratoryContractSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ILaboratoryContractSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYCONTRACT_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ILaboratoryContractClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_LABORATORYCONTRACT_CLEAR,
            propertiesToClear
        }
    },

    Filter: ILaboratoryContractFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_LABORATORYCONTRACT_FILTER,
            formFilter
        }
    };



export const
    ACTION_LABORATORYCONTRACT_LOAD_BY_LABORATORY_ID = "ACTION_LABORATORYCONTRACT_LOAD_BY_LABORATORY_ID",
    ACTION_LABORATORYCONTRACT_LOAD_BY_ID = "ACTION_LABORATORYCONTRACT_LOAD_BY_ID",
    ACTION_LABORATORYCONTRACT_LOAD_SUCCESS = "ACTION_LABORATORYCONTRACT_LOAD_SUCCESS",
    ACTION_LABORATORYCONTRACT_LOAD_FAILURE = "ACTION_LABORATORYCONTRACT_LOAD_FAILURE",

    ACTION_LABORATORYCONTRACT_SAVE = "ACTION_LABORATORYCONTRACT_SAVE",
    ACTION_LABORATORYCONTRACT_SAVE_SUCCESS = "ACTION_LABORATORYCONTRACT_SAVE_SUCCESS",
    ACTION_LABORATORYCONTRACT_SAVE_FAILURE = "ACTION_LABORATORYCONTRACT_SAVE_FAILURE",

    ACTION_LABORATORYCONTRACT_VALIDATE = "ACTION_LABORATORYCONTRACT_VALIDATE",
    ACTION_LABORATORYCONTRACT_VALIDATE_SUCCESS = "ACTION_LABORATORYCONTRACT_VALIDATE_SUCCESS",
    ACTION_LABORATORYCONTRACT_VALIDATE_FAILURE = "ACTION_LABORATORYCONTRACT_VALIDATE_FAILURE",

    ACTION_LABORATORYCONTRACT_CREATE = "ACTION_LABORATORYCONTRACT_CREATE",
    ACTION_LABORATORYCONTRACT_CREATE_SUCCESS = "ACTION_LABORATORYCONTRACT_CREATE_SUCCESS",
    ACTION_LABORATORYCONTRACT_CREATE_FAILURE = "ACTION_LABORATORYCONTRACT_CREATE_FAILURE",

    ACTION_LABORATORYCONTRACT_SYNC = "ACTION_LABORATORYCONTRACT_SYNC",
    ACTION_LABORATORYCONTRACT_SYNC_SUCCESS = "ACTION_LABORATORYCONTRACT_SYNC_SUCCESS",
    ACTION_LABORATORYCONTRACT_SYNC_FAILURE = "ACTION_LABORATORYCONTRACT_SYNC_FAILURE",

    ACTION_LABORATORYCONTRACT_CLEAR = "ACTION_LABORATORYCONTRACT_CLEAR",

    ACTION_LABORATORYCONTRACT_FILTER = "ACTION_LABORATORYCONTRACT_FILTER";

export interface ILaboratoryContractLoadByLaboratoryIdAction {
    type: "ACTION_LABORATORYCONTRACT_LOAD_BY_LABORATORY_ID";
    laboratoryId: number;
}

export interface ILaboratoryContractLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): ILaboratoryContractLoadByLaboratoryIdAction;
}

export interface ILaboratoryContractLoadSuccessAction {
    type: "ACTION_LABORATORYCONTRACT_LOAD_SUCCESS";
    formData: Dtos.LaboratoryContract | Dtos.LaboratoryContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryContractLoadSuccessActionCreator {
    (
        formData: Dtos.LaboratoryContract | Dtos.LaboratoryContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryContractLoadSuccessAction;
}

export interface ILaboratoryContractLoadFailureAction {
    type: "ACTION_LABORATORYCONTRACT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryContractLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryContractLoadFailureAction;
}

export interface ILaboratoryContractLoadByIdAction {
    type: "ACTION_LABORATORYCONTRACT_LOAD_BY_ID";
    id: number;
}

export interface ILaboratoryContractLoadByIdActionCreator {
    (id: number): ILaboratoryContractLoadByIdAction;
}

export interface ILaboratoryContractSaveAction {
    type: "ACTION_LABORATORYCONTRACT_SAVE";
    formData: Dtos.LaboratoryContract;

}

export interface ILaboratoryContractSaveActionCreator {
    (
        formData: Dtos.LaboratoryContract
    ): ILaboratoryContractSaveAction;
}

export interface ILaboratoryContractSaveSuccessAction {
    type: "ACTION_LABORATORYCONTRACT_SAVE_SUCCESS";
    formData: Dtos.LaboratoryContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryContractSaveSuccessActionCreator {
    (
        formData: Dtos.LaboratoryContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryContractSaveSuccessAction;
}

export interface ILaboratoryContractSaveFailureAction {
    type: "ACTION_LABORATORYCONTRACT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryContractSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryContractSaveFailureAction;
}

export interface ILaboratoryContractValidateAction {
    type: "ACTION_LABORATORYCONTRACT_VALIDATE";
    formData: Dtos.LaboratoryContract;

}

export interface ILaboratoryContractValidateActionCreator {
    (
        formData: Dtos.LaboratoryContract
    ): ILaboratoryContractValidateAction;
}

export interface ILaboratoryContractValidateSuccessAction {
    type: "ACTION_LABORATORYCONTRACT_VALIDATE_SUCCESS";
    formData: Dtos.LaboratoryContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryContractValidateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryContractValidateSuccessAction;
}

export interface ILaboratoryContractValidateFailureAction {
    type: "ACTION_LABORATORYCONTRACT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryContractValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryContractValidateFailureAction;
}

export interface ILaboratoryContractCreateAction {
    type: "ACTION_LABORATORYCONTRACT_CREATE",
    laboratoryId: number
}

export interface ILaboratoryContractCreateActionCreator {
    (laboratoryId: number): ILaboratoryContractCreateAction
}

export interface ILaboratoryContractCreateSuccessAction {
    type: "ACTION_LABORATORYCONTRACT_CREATE_SUCCESS";
    formData: Dtos.LaboratoryContract;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ILaboratoryContractCreateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryContract,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ILaboratoryContractCreateSuccessAction;
}

export interface ILaboratoryContractCreateFailureAction {
    type: "ACTION_LABORATORYCONTRACT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryContractCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryContractCreateFailureAction;
}

export interface ILaboratoryContractClearAction {
    type: "ACTION_LABORATORYCONTRACT_CLEAR";
    propertiesToClear?: string[];
}

export interface ILaboratoryContractClearActionCreator {
    (propertiesToClear?: string[]): ILaboratoryContractClearAction;
}

export interface ILaboratoryContractFilterActionCreator {
    (formFilter: IFormFilter): ILaboratoryContractFilterAction;
}

export interface ILaboratoryContractFilterAction {
    type: "ACTION_LABORATORYCONTRACT_FILTER";
    formFilter: IFormFilter;
}

export interface ILaboratoryContractSyncAction {
    type: "ACTION_LABORATORYCONTRACT_SYNC",
    laboratoryId: number
}

export interface ILaboratoryContractSyncActionCreator {
    (laboratoryId: number): ILaboratoryContractSyncAction
}

export interface ILaboratoryContractSyncSuccessAction {
    type: "ACTION_LABORATORYCONTRACT_SYNC_SUCCESS";
    formData: Dtos.LaboratoryContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryContractSyncSuccessActionCreator {
    (
        formData: Dtos.LaboratoryContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryContractSyncSuccessAction;
}

export interface ILaboratoryContractSyncFailureAction {
    type: "ACTION_LABORATORYCONTRACT_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryContractSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryContractSyncFailureAction;
}

export type LaboratoryContractAction =
    ILaboratoryContractLoadByLaboratoryIdAction |
    ILaboratoryContractLoadByIdAction |
    ILaboratoryContractLoadFailureAction |
    ILaboratoryContractLoadSuccessAction |
    ILaboratoryContractSaveAction |
    ILaboratoryContractSaveSuccessAction |
    ILaboratoryContractSaveFailureAction |
    ILaboratoryContractValidateAction |
    ILaboratoryContractValidateSuccessAction |
    ILaboratoryContractValidateFailureAction |
    ILaboratoryContractCreateAction |
    ILaboratoryContractCreateSuccessAction |
    ILaboratoryContractCreateFailureAction |
    ILaboratoryContractSyncAction |
    ILaboratoryContractSyncSuccessAction |
    ILaboratoryContractSyncFailureAction |
    ILaboratoryContractClearAction | 
    ILaboratoryContractFilterAction;
